import http from '../http'
import {INSTITUTION_LIST_URL, INSTITUTION_CREATE_URL, INSTITUTION_EDIT_URL} from '../../services/endpoints'

export function getInstitutionList(params) {
  return http.request({
    url:INSTITUTION_LIST_URL,
    method:'get',
    params
  })
}

export function createInstitution(data) {
  return http.request({
    url:INSTITUTION_CREATE_URL,
    method:'post',
    data:data
  })
}

export function updateInstitution(id, data){
  return http.request({
    url:INSTITUTION_EDIT_URL(id),
    method:'put',
    data:data
  })
}
export function deleteInstitution(id){
  return http.request({
    url:INSTITUTION_EDIT_URL(id),
    method:'delete'
  })
}
export function getInstitution(id){
  return http.request({
    url:INSTITUTION_EDIT_URL(id),
    method:'get'
  })
}
